import { render } from "./PediatricHistoryForm.vue?vue&type=template&id=5cb706ae&ts=true"
import script from "./PediatricHistoryForm.ts?vue&type=script&lang=ts&external"
export * from "./PediatricHistoryForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__